import React, { Component } from 'react'
import './loading-page.css';
export default class LoadingPage extends Component {
    render () {
        return (
            <div>
                <div class="loading">Loading&#8230;</div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/loading-page/loading-page.js